__turbopack_context__.v({
  "btn__close": "GBQoIG_btn__close",
  "modal": "GBQoIG_modal",
});
